import React, { Component } from 'react';
import $ from 'jquery'; 
import Selector from '../Selector';
// Images
//import Constants from '../../constants.js'
window.jQuery = $;

class IntroPanel extends Component {

    render() {
        var contentWrapper = $('.intro-panel').find('.section');
        var regionData = $('.team-member-data').find("[data-location='Main']").html();

        $(document).ready(()=>{

            contentWrapper.html(regionData);


        });

        return(
            <div className="section-results">
                <div className="intro-panel">
                    <div className="section"></div>
                </div>
            </div>
        )
    }
}

export default IntroPanel;


// WEBPACK FOOTER //
// ./src/js/components/layout/IntroPanel.js